<template>
    <el-dialog title="" :show-close="true" class="dialog-container" :visible.sync="dialogVisible" width="1000px" top="57px">

        <div class="dialog-header">
            <div>选择课程</div>
        </div>

        <div class="parts-container gap">

            <div class="parts-wrapper">
                <div class="parts-header">
                    <div class="left">
                        <el-checkbox v-model="checkedAll" @change="selectAll">全选</el-checkbox>
                    </div>
                    <div class="right">已选择{{ courseOptions.length }}门/共{{ courseData.length }}门</div>
                </div>
                <div class="ports-content">
                    <div class="search-wrapper">
                        <el-input placeholder="输入课程名称" v-model="searchCourse" style="width: 100%">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            <span slot="suffix" class="btn animate" @click="searchCourseData">搜索</span>
                        </el-input>
                    </div>
                    <div class="course-wrapper">
                        <div v-for="(item, key) in courseData" :key="key" class="course-row">
                            <el-checkbox v-model="item.value" @change="changeCourse(item)">
                                <div style="width: 900px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                    {{ item.courseName
                                    }}</div>
                                <div class="teacher">录播 | {{ item.courseTime }}分钟</div>
                            </el-checkbox>

                        </div>
                        <div v-if="courseData.length > 0 && currentPage < totalPages" class="more-btn" @click="viewMore">
                            查看更多
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <span slot="footer" class="dialog-footer">

            <el-button type="primary" @click="handleDeal">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {

    studyRecordCourseList, courseGroupDetail

} from "@/api/index.js";
export default {
    name: '',

    data() {
        return {
            dialogVisible: false,
            checkedAll: false,
            dept: '',
            token: '',
            /**选择的课程 */
            courseOptions: [],
            searchCourse: "", currentPage: 1, courseData: [],
        }
    },
    watch: {
        courseOptions: {
            handler(newValue, oldValue) {

                if (newValue.length == this.courseData.length) {

                    this.checkedAll = true
                } else {
                    this.checkedAll = false
                }
            },
            deep: true, // 深度监听 nestedObject 的变化
        }
    },
    created() {
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
    },
    mounted() {
        this.queryCourseData();
    },
    methods: {
        shwo() {
            this.courseData.forEach(item1 => {
                item1.value = false;

            });

            this.courseOptions = []

            this.dialogVisible = true
        },
        selectAll() {
            if (this.checkedAll) {
                this.courseOptions = this.courseData
                //     this.courseData.map(item => {
                //     return item.courseId
                // })
                this.courseData.filter(item => {
                    item.value = true
                })
            } else {
                this.courseOptions = []
                this.courseData.filter(item => {
                    item.value = false
                })
            }

        },
        handleDeal() {
            this.dialogVisible = false
            if (this.courseOptions.length) {
                console.log(this.courseOptions, '选中了***')
                // this.dialogVisible = false
                this.$emit('setKCdATE', this.courseOptions)
            } else {
                // this.$message.error('请选择课程');
            }
        },
        changeCourse(row) {
            console.log(row)
            if (row.value) {
                this.courseOptions.push(row);
            } else {
                let courseOptions = this.courseOptions;
                this.courseOptions = courseOptions.filter((item) => {
                    return item.courseId != row.courseId;
                });
            }

        },

        searchCourseData() {
            this.currentPage = 1;
            this.courseData = [];
            this.queryCourseData();
        },
        async queryCourseData() {
            await studyRecordCourseList(
                {
                    deptId: 0,
                    keyword: this.searchCourse,
                    pageNum: this.currentPage,
                    pageSize: 1000,
                },
                {
                    Authorization: this.token,
                    DeptId: this.dept,
                }
            )
                .then((res) => {
                    if (res.code == 200) {
                        console.log(res.data.list, 'res.data.list')
                        let data = res.data.list;
                        let newArr = data.map((item) => {
                            item["value"] = false;
                            return item;
                        });
                        const tableArr = this.courseData;
                        this.courseData = tableArr.concat(newArr);
                        this.totalPages = res.data.totalPages;
                        this.totalRows = res.data.totalRecords;
                        /**编辑回显 */
                        if (this.status == "course-edit") {
                            // console.log('编辑回显')
                            this.getCourseDetail();
                        }
                    }
                    return;
                })
                .catch((err) => {
                    // console.log(err);
                });
        },
        async getCourseDetail() {
            const row = this.row;
            await courseGroupDetail(
                row.courseGroupId,
                {},
                {
                    Authorization: this.token,
                    DeptId: this.dept,
                }
            )
                .then((res) => {
                    if (res.code == 200) {
                        console.log(res, '获取课程详情数据')
                        const data = res.data;
                        this.courseTitle = data.courseGroupName;
                        this.courseGroupId = res.data.courseGroupId
                        this.editInit(data);
                        this.useList = data.studyMemList.map(item => { return item.userId })

                        this.userALL = this.compareArraysById(this.useList, this.NewuserList);
                    }
                    return;
                })
                .catch((err) => {
                    // console.log(err);
                });
        },


        //过滤用户
        compareArraysById(array1, array2) {
            // 使用 filter 和 find 方法找出两个数组中ID相同的元素
            return array1
                .filter((item1) => array2.some((item2) => item1 === item2.userId))
                .map((item1) => {
                    // 使用 find 方法找到 array2 中具有相同 ID 的元素
                    const matchingItem2 = array2.find((item2) => item1 === item2.userId);
                    // 如果找到了，合并两个对象的属性；否则只返回 array1 中的元素
                    return matchingItem2 ? { ...item1, ...matchingItem2 } : item1;
                });
        },

        viewMore() {
            const currentPage = this.currentPage;
            if (currentPage < this.totalPages) {
                this.currentPage = currentPage + 1;
                this.queryCourseData();
            } else {
                this.$message({
                    message: "没有更多了",
                    type: "warning",
                });
            }
        },


    }
}
</script>

<style scoped>
.parts-container {
    height: 100%;
    flex: 1;




}

.parts-wrapper {


    margin-top: 16px;
    display: flex;
    flex-direction: column;


}

.parts-header {
    height: 52px;

    border-radius: 8px 8px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;


}

.left {
    margin-left: 28px;


}

/deep/.left>.el-checkbox>.el-checkbox__input {

    margin-top: 1px;
}

/deep/ .el-checkbox {
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

/deep/ .el-checkbox__label {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.right {
    margin-right: 29px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606a74;
}

.ports-content {
    flex: 1;
    padding: 19px 0px 0px 0px;
    display: flex;
    flex-direction: column;


}

.search-wrapper {
    height: 40px;
    padding: 0px 29px 0px 29px;


}

.btn {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3e63ee;
    line-height: 40px;
    margin-right: 15px;
}

.btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.operate-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;


}

.info {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    display: inline-block;
}

.add-btn {
    color: #3e63ee;
    cursor: pointer;
    display: inline-block;
}

.students-wrapper {
    height: 570px;
    overflow-x: hidden;
    overflow-y: auto;


}

.students-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0px 20px 0px;
    margin: 0px 30px 0px 30px;
    border-bottom: 1px solid #eaeaea;


}

.info {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;


}

.btn {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3e63ee;
}

.gap {
    width: 100%;

}

.btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.course-wrapper {
    height: 570px;
    overflow-x: hidden;
    overflow-y: auto;


}

.course-row {
    padding: 20px 0px 20px 0px;
    margin: 0px 30px 0px 30px;
    border-bottom: 1px solid #eaeaea;


}

/deep/ .el-checkbox {
    display: flex;
}

/deep/ .el-checkbox__input {
    display: inline-block;
    margin-top: 10px;
}

/deep/ .el-checkbox__label {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    width: 100%;
    white-space: normal;
    word-break: break-all;
}

.teacher {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606a74;
    line-height: 22px;
    margin-top: 8px;
    /* margin-left: 25px; */
}

.more-btn {
    text-align: center;
    margin: 15px 0px 15px 0px;
    font-size: 14px;
    color: #606a74;
}

.more-btn:hover {
    cursor: pointer;
    color: #3e63ee;
}

.title-wrapper {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;


}

.require {
    color: #eb6c48;
}



.dialog-container>>>.el-dialog__body {
    padding: 0px !important;
}

.dialog-container>>>.el-dialog__header {
    padding: 0px !important;
}

.dialog-content>>>.el-form-item__label {
    text-align: left !important;
    font-size: 16px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    color: #333333 !important;
}

.dialog-content>>>.el-input__inner {
    height: 40px !important;
    background: #FFFFFF !important;
    border-radius: 6px !important;
    border: 1px solid #D9D9D9 !important;
}

.dialog-form-option-radio {
    margin-top: 3px;
    height: 30px;
    line-height: 30px;
}

.dialog-header {
    width: 100%;
    height: 52px;
    background: rgb(244, 244, 244);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}

.dialog-content {
    padding: 16px 40px 0px 40px;
    display: flex;
}

.dialog-content-item1 {
    width: 500px;


}

.dialog-content-item2 {
    width: 500px;


}

.dialog-form-label {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 15px;
    display: flex;
}

.dialog-label-block {
    width: 140px;
    display: flex;
}

.dialog-form-content {
    width: 100%;
    margin-top: 12px;
}

.dialog-form-require {
    color: #EB6C48;
    font-size: 12px;
    margin-left: 2px;
}

.dialog-form-checkbox-container {
    height: 219px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #D9D9D9;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
}

.dialog-form-checkbox-wrapper {
    flex: 1;
    margin-top: 5px;
    margin-bottom: 5px;
}

.dialog-form-checkbox {
    flex: 1;
    margin-left: 16px;
    /* display: flex; */
    margin-bottom: 5px;
    margin-top: 5px;
}

.dialog-form-all-check {
    margin-left: 16px;
}

.dialog-form-checkbox>>>.el-checkbox {
    font-size: 18px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    color: #606A74 !important;
}

.dialog-form-checkbox>>>.el-radio {
    font-size: 18px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    color: #606A74 !important;
}

.dialog-count-unit {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    display: flex;
    align-items: center;
    margin-left: 7px;
}

.dialog-form-brief {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 27px;
    margin-top: 77px;
}

.dialog-form-line {
    width: 1px;
    height: 594px;
    background: #F0F0F0;
    margin: 16px 52px 0px 52px;
}

.dialog-form-textarea {
    width: 400px;
    margin-left: 10px;
}

.dialog-form-option-wrapper {
    display: flex;
    margin-bottom: 7px;
}

.dialog-form-option-input {
    flex: 1;
    display: flex;
    margin-left: 9px;
}

.dialog-form-option-input>>>.el-input__inner {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}

.dialog-footer {
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: end;
}



.dialog-footer-btn {
    width: 108px;
    height: 44px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
}

.dialog-footer-cancel {
    color: #4F79ED;
    border: 1px solid #4F79ED;
}

.dialog-footer-deal {
    background: #3E63EE;
    color: #fff;
    margin-right: 40px;
    margin-left: 20px;
}

.dialog-footer-cancel:hover {
    background: #4F79ED;
    color: #fff;
    cursor: pointer;
}

.dialog-footer-deal:hover {
    cursor: pointer;
    opacity: 0.8;
}

.dialog-btn-wrapper {
    padding: 0px 40px 40px 40px;
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
}
</style>


